import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import axios from 'axios';

export async function exportListPDF({ title, headers, rows, totalLabel, totalValue, token, apiUrl }) {
  let logo = null;
  try {
    const res = await axios.get(`${apiUrl}/settings`, { headers: { Authorization: `Bearer ${token}` } });
    logo = res.data?.company_logo;
  } catch {}

  const doc = new jsPDF();
  const today = new Date().toLocaleDateString();
  let startY = 15;

  if (logo) {
    try {
      doc.addImage(logo, 'AUTO', 14, 10, 25, 25);
      doc.setFontSize(18);
      doc.setTextColor(30, 58, 138);
      doc.text(title, 44, 22);
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(`Created: ${today}`, 44, 29);
      startY = 42;
    } catch {
      doc.setFontSize(18);
      doc.setTextColor(30, 58, 138);
      doc.text(title, 14, 20);
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text(`Created: ${today}`, 14, 27);
      startY = 34;
    }
  } else {
    doc.setFontSize(18);
    doc.setTextColor(30, 58, 138);
    doc.text(title, 14, 20);
    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text(`Created: ${today}`, 14, 27);
    startY = 34;
  }

  autoTable(doc, {
    startY,
    head: [headers],
    body: rows,
    theme: 'grid',
    headStyles: { fillColor: [30, 58, 138], fontSize: 9 },
    styles: { fontSize: 8, cellPadding: 3 },
  });

  if (totalLabel && totalValue) {
    const finalY = doc.lastAutoTable.finalY + 8;
    doc.setFontSize(11);
    doc.setFont(undefined, 'bold');
    doc.setTextColor(0);
    doc.text(`${totalLabel}: ${totalValue}`, 14, finalY);
  }

  doc.save(`${title.toLowerCase().replace(/\s+/g, '-')}-${new Date().toISOString().split('T')[0]}.pdf`);
}
